/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext } from 'react';

import {
  NetworkConcerns,
  NetworkInterface,
  NetworkInterfaceConcern,
} from '@totem/components/networkConcerns/types';

interface Context {
  reportData: NetworkConcerns;
  interfaceData: NetworkInterfaceConcern[];
  loading: boolean;
  loadingInterfaces: boolean;
  onAction: (action: string) => void;
}

export default createContext<Context>({
  loading: false,
  loadingInterfaces: false,
  reportData: null,
  interfaceData: [],
  onAction: (action: string) => {},
});
